export default __webpack_public_path__ + "static/media/Shadow's Bracers of the Stolen Kingdom.8dbc16d2.jpg";